const Routes = {
  DEALS: 'deals',
  ARCHIVED_DEALS: 'archivedDeals',
  DEAL_PAGE: 'dealPage',
  PIPELINE: 'pipelinePage',
  PIPELINE_CONFIG: 'pipelineConfig',
  PROJECT_PAGE: 'projectPage',
  CUSTOMERS: 'customers',
  USERS: 'users',
  USER: 'user',
  INBOX: 'inbox',
  ITEM_GROUPS: 'itemGroups',
  ITEMS: 'items',
  INVOICES: 'invoices',
  NEW_QUOTE: 'newQuote',
  EDIT_QUOTE: 'editQuote',
  EDIT_NEW_QUOTE: 'editNewQuote',
  LEGACY_INVOICE: 'legacyInvoice',
  LEGACY_PROPOSAL: 'legacyProposal',

  EDIT_PROPOSAL_LINE_ITEM: 'editProposalLineItem',
  EDIT_PROTO_INVOICE_LINE_ITEM: 'editProtoInvoiceLineItem',

  INVOICE: 'invoice',
  EDIT_INVOICE: 'editInvoice',
  EDIT_PROTO_INVOICE: 'editProtoInvoice',

  ITEM: 'item',
  EDIT_ITEM_GROUP: 'editItemGroup',
  NEW_CUSTOMER: 'newCustomer',
  EDIT_CUSTOMER: 'editCustomer',
  CUSTOMER: 'customer',
  PERSONAL_SETTINGS: 'personalSettings',
  COMPANY_SETTINGS: 'companySettings',
  UPGRADE_ACCOUNT: 'upgradeAccount',
  ENABLE_CUSTOMER_PAYMENTS: 'enableCustomerPayments',
  VERIFY_USER: 'verifyUserAccount',
  LOGIN: 'login',
  APPLE_CALLBACK: 'appleCallback',
  XERO_CALLBACK: 'xeroCallback',
  REGISTER: 'register',
  FORGOT_PASSWORD: 'forgotPassword',
  RESET: 'reset',
  USER_INVITE: 'userInvite',
  EMBEDDABLE_ANALYTICS_DASHBOARD: 'embeddableAnalyticsDashboard',
  DASHBOARD: 'dashboard',
  DASHBOARD_NEW: 'dashboardNew',
  RESOURCES: 'resource',
  SETUP_BUSINESS_PAGE: 'setupBusinessPage',
  SETUP_USER: 'setupUser',
  LOGIN_OAUTH: 'loginOAuth',
  OAUTH2_AUTHORIZE: 'oauth2Authorize',
  DEV: 'dev',
  GRANT_ACCESS: 'grantAccess',
  SCHEDULE: 'schedule',
  SCHEDULE_DISPATCH: 'scheduleDispatch',
  PAYACA_CREDIT_PAGE: 'credit',
  NEW_EDIT_FORM: 'forms',
  CREATE_FORM: 'createForm',
  DOCUMENT_OVERVIEW_PAGE: 'documentOverviewPage',
  CHOSEN_REPORT_PAGE: 'chosenReportPage',
  AUTOMATIONS_PAGE_OLD: 'automationsPageOld',
  AUTOMATIONS_PAGE: 'automationsPage',
  AUTOMATIONS_REBUILD_PAGE: 'automationsRebuildPage',
  CREATE_EDIT_AUTOMATION_PAGE: 'createEditAutomationPage',
  LISTED_TASKS: 'listedTasks',
  LISTED_SUPPLIERS: 'listedSuppliers',
  SUPPLIER: 'supplier',
  LISTED_STOCK_LOCATIONS: 'listedStockLocations',
  STOCK_LOCATION: 'stockLocation',
  LISTED_MATERIALS: 'listedMaterials',
  MATERIAL: 'material',
  EDIT_ISOLATED_PURCHASE_ORDER: 'editIsolatedPurchaseOrder',
  VIEW_PURCHASE_ORDER: 'viewPurchaseOrder',
  PURCHASE_ORDER_PDF_DOCUMENT: 'purchaseOrderPdfDocument',
  CHANGE_PROPOSAL: 'changeProposal',
  CHANGE_PROPOSAL_PDF_DOCUMENT: 'changeProposalPdfDocument',
  INVOICE_PDF_DOCUMENT: 'invoicePdfDocument',
  PROTO_INVOICE_PDF_DOCUMENT: 'protoInvoicePdfDocument',
  EDIT_CHANGE_PROPOSAL: 'editChangeProposal',
  CSV_UPLOADS: 'csv-uploads',
  SERVICE_PLANS: 'service-plans',
  SERVICE_PLAN: 'service-plan',
  SERVICE_PLAN_PERIOD: 'service-plan-period',
  DISCOUNT_CODES: 'discount-codes',
  CUSTOMER_REMINDERS: 'customer-reminders',
  DISPATCH: 'dispatch',
  EDIT_ITEM: 'editItem',
  CREATE_ITEM: 'createItem',
  CLEAR_CACHE: 'clearCache',
  LEGACY_USERS: 'legacyUsers',
  LEGACY_TAGS: 'legacyTags',
  LEGACY_TEMPLATES: 'legacyTemplates',
  LEGACY_DOCUMENT_BLUEPRINTS: 'legacyDocumentBlueprints',
  LEGACY_CONNECTIONS: 'legacyConnections',
  TIMELOG_REPORTING: 'timelogReporting',

  CREATE_EDIT_ENTITY_TEMPLATE: 'createEditEntityTemplate',
  CREATE_EDIT_DOCUMENT_TEMPLATE: 'createEditDocumentTemplate',
  CREATE_DOCUMENT_TEMPLATE: 'createDocumentTemplate',
  CREATE_DOCUMENT_TEMPLATE_MANUAL: 'createDocumentTemplateManual',
  PREVIEW_DOCUMENT_INSTANCE: 'previewDocumentInstance',
  DOCUMENT_BLUEPRINT_PREVIEW: 'documentBlueprintPreview',

  CONNECTION_APPLICATION: 'connectionApplication',
  CONNECTION_APPLICATION_COMMISSIONING: 'connectionApplicationCommissioning',

  LISTED_CHILD_ACCOUNTS: 'listedChildAccounts',
  CHILD_ACCOUNT: 'childAccount',

  ADD_APPLIANCE: 'addAppliance',
  EDIT_APPLIANCE: 'editAppliance',

  ESTIMATE_BUILDER: 'estimateBuilder',
  SOLAR_DESIGNER: 'solarDesigner',

  NEW_PROPOSAL_V2: 'newProposalV2',
  PROPOSAL_BUILDER_V2: 'proposalBuilderV2',
};

export { Routes };
